import { effect, inject, Injector, Signal, untracked } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { AlertStore } from '@alert/data-access';
import { HttpErrorResponse } from "@angular/common/http";

export interface IErrorStore {
  error: any;
}

export const initialErrorStore: IErrorStore = {
  error: null,
};

export const ErrorStore = signalStore(
  {providedIn: 'root'},
  withState(initialErrorStore),
  withMethods((state, alertStore = inject(AlertStore)) => {

    const getHttpErrorObject = (error: HttpErrorResponse): any => {
      if (error?.error?.ValidationResult) {
        return error.error.ValidationResult;
      }
    
      if (error?.error?.Errors?.length) {
        return error.error.Errors;
      }
      if (error?.error?.errors) {
        return  error.error.errors;
      }
      return error
    }

    const getHttpErrorMessage = (error: HttpErrorResponse): string | null => {
      if (error?.error?.message && typeof error?.error?.message === 'string') return error.error.message;
      if (error?.error?.Message && typeof error?.error?.Message === 'string') return error.error.Message;

      if (error?.error?.Errors && Array.isArray(error.error.Errors)) {
        const messages = error.error.Errors.map((element: any) => element?.ErrorMessage).filter(Boolean);
        if (messages.length) {
          return messages.join('\n');
        }
      }

      if (error?.error?.Erros && Array.isArray(error.error.Erros)) {
        return error.error.Erros[0];
      }

      if (error?.error?.errors) {
        const errorKeys = Object.keys(error.error.errors);
        return error.error.errors[errorKeys[0]][0];
      }
      if (error?.error?.Validacao?.Erros) return error.error.Validacao.Erros;
      if (error?.error?.ValidationResult?.Errors) return error.error.ValidationResult.Errors.map((element: any) => typeof element === 'object' ? element.ErrorMessage : element)[0];
      if (error?.error?.ModelState?.Erros) return error.error.ModelState.Erros;
      if (error?.error?.errors?.DomainValidations) return error.error.errors.DomainValidations;
      if (error?.error?.Erros) return error.error.Erros;
      if (error?.error?.Validacao?.Errors) {
        const messages = error?.error?.Validacao?.Errors?.map((element: any) => element?.Message).filter(Boolean);
       
        if (messages.length) {
          return messages.join('\n');
        }
      };
      return null;
    }

    const handleHttpError = (error: HttpErrorResponse, title?: string, message?: string): void => {
      const errorMessage: string | null = getHttpErrorMessage(error) || message;

      if (errorMessage) openAlert(errorMessage, title);
      else {
        if (error.status === 400) openAlert('ALERT.ERROR_400', title);
        if (error.status === 404) openAlert('ALERT.ERROR_404', title);
        if (error.status === 401 || error.status === 403) openAlert('ALERT.ERROR_401', title);
        if (error.status === 500 || error.status === 0) openAlert('ALERT.ERROR_500', title, true);
      }
    }

    const openAlert = (message: string, title?: string, isDanger?: boolean) => {
      alertStore.create({
        message: message ?? 'ALERT.GENERIC_ERROR_MESSAGE',
        title: title ?? 'ALERT.GENERIC_ERROR_TITLE',
        type: isDanger ? 'danger' : 'warning'
      });
    }


    const handleError = ({ error, title, message }: { error?: HttpErrorResponse | Error, title?: string, message?: string } = { }) => {
      if (error instanceof HttpErrorResponse) {
        handleHttpError(error, title, message)
        return;
      }
      openAlert(error?.message || message, title);
    }
    return {
      getHttpErrorObject,
      getHttpErrorMessage,
      handleError,
      setHttpError: (payload: HttpErrorResponse) => {
        patchState(state, { error: payload })
        handleHttpError(payload);
      },
      setJavascriptError: (payload: any) => {
        patchState(state, { error: payload })
      },
      createErrorAlertsBySignals: (configs: { signals: Signal<HttpErrorResponse | Error>[]; title?: string; message?: string }[], injector: Injector) => {
        for(let { signals, title, message } of configs) {
          for (let signal of signals ) {
            effect(() => {
              const error = signal();
              if (error) untracked(() => handleError({ error, title, message }));
            }, { injector })
          }
        }
      }
    }
  })

);
